import { render, staticRenderFns } from "./StudentEducation.vue?vue&type=template&id=11974f2a&scoped=true&"
import script from "./StudentEducation.vue?vue&type=script&lang=js&"
export * from "./StudentEducation.vue?vue&type=script&lang=js&"
import style0 from "./StudentEducation.vue?vue&type=style&index=0&id=11974f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11974f2a",
  null
  
)

export default component.exports